// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"194":"97a5a6d7","375":"0426ecef","789":"28633b43","821":"67e216a7","943":"bfcabda3","998":"490f8583"}[chunkId] + ".chunk.js";
};